import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Sirve si soy principiante?',
    a: 'Totalmente. El manual está diseñado para llevarte paso a paso, desde los conceptos más básicos hasta tácticas avanzadas del fútbol moderno.'
  }, {
    q: '¿Es muy teórico?',
    a: 'No. Está lleno de ejemplos prácticos, situaciones reales de partido y soluciones directas que podés aplicar en tu próximo entrenamiento o partido.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Inmediatamente después de la compra, vas a recibir un correo electrónico con el enlace para descargar el PDF completo y todos los bonos en tu celular, tablet o computadora.'
  }, {
    q: '¿Sirve para fútbol 5 o 7?',
    a: 'Aunque está enfocado en fútbol 11, los conceptos de duelos 1vs1, perfil corporal y toma de decisiones son aplicables a cualquier formato.'
  }];
  return <section className="py-16 px-4 bg-[#f8f9fa]" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <h2 className="text-3xl text-center text-[#1a3d1f] mb-10 uppercase font-bold" style={{
        fontFamily: 'Anton, sans-serif'
      }} data-id="element-63">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-65">
              <button className="w-full px-6 py-4 flex justify-between items-center text-left" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-66">
                <span className="font-bold text-[#1a3d1f]" data-id="element-67">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>
              {openIndex === index && <div className="px-6 pb-4 text-gray-600" data-id="element-69">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}